import styled from "styled-components";
import { Button as AntButton, Form as AntForm, Input as AntInput } from "antd";
import { LeftStars, RightStars } from "@assets";

export const ChangePinContainer = styled.div`
	min-height: calc(100vh - 110px);
	display: flex;
	justify-content: flex-start;
	align-items: left;
	flex-direction: column;
	/* padding: 20px 0px; */

	.ant-form-item-label {
		text-align: center;
		font-size: 16px;
	}

	.ant-input {
		text-align: center;
	}
`;

export const Form = styled(AntForm)`
	width: 100%;
	height: 100%;
	position: relative !important;
	padding: 16px;

	.ant-form-item {
		margin: 0 0 24px 0px;
	}

	.ant-form-item-label > label.ant-form-item-required::before {
		content: none;
	}

	.ant-form-item-label label {
    color: #2A2A2A !important;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 171.429% */
	}

	.ant-form-item-explain {
		text-align: left; /* align warning text to the left */
		margin-left: 24px;
	}
`;

export const ChangePinTitle = styled.p`
	font-weight: 500;
	font-size: 16px;
	line-height: 24.17px;
	color: #ffffff;
	text-align: center;

	@media screen and (max-width: 440px) {
		font-size: 14px;
	}

	@media screen and (max-width: 385px) {
		font-size: 12px;
	}
`;

export const SubTitle = styled.p`
	font-size: 12px;
	font-weight: 400;
	line-height: 18.8px;
	color: #ffffff;
`;

export const Button = styled(AntButton)`
	margin-top: 20px;
	width: 100% !important;
	height: 52px !important;

	border-radius: 8px !important;
	background: linear-gradient(133deg, #FFD648 -3.8%, #AA5E1B 100%);

	color: #2A2A2A !important;
	text-align: center;
	font-size: 16px;
	font-style: normal;
	font-weight: 700;
	line-height: 26px; /* 162.5% */

	&:hover {
	color: #2A2A2A !important;
	background: linear-gradient(133deg, #FFD648 -3.8%, #AA5E1B 100%) !important;
	}
`;

export const Input = styled(AntInput.Password)`
	border-radius: 8px;
	border: none;
	height: 54px;

	input {
		font-size: 16px !important ;
		text-align: left !important;
		font-style: normal;
		font-weight: 500;
		line-height: normal;
		color: #000000 !important;
	}

	.ant-input {
		font-size: 17px !important;
	}

	.ant-input::placeholder {
    color: #9F9F9F !important;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
	}

	&&& {
		padding-left: 24px;
	}
	input:hover {
		border: none !important;
	}
`;

export const TitleDiv = styled.div`
	height: 87px;
	background-color: #49028e;
	border-bottom-left-radius: 16px;
	border-bottom-right-radius: 16px;
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;
	padding: 0 12px;
`;

export const TitleWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 10px;
	padding: 3px 0;
`;

export const LeftStarsGroup = styled(LeftStars)`
	position: absolute;
	left: 10px;
`;

export const RightStarsGroup = styled(RightStars)`
	position: absolute;
	right: 10px;
`;
